import * as clipboard from './utils/clipboard.js';

let isSharingInProgress = false;

export function shareUrl({ text, url }) {
  if (isSharingInProgress) {
    console.warn('Share is already in progress.');
    return;
  }

  const preparedText = text ? `${text} ${url}` : url;

  try {
    if (navigator.canShare && navigator.canShare({ text: preparedText })) {
      isSharingInProgress = true;
      navigator.share({ text: preparedText });
    } else {
      clipboard.add(preparedText);
      window.prompt('Copy the link', preparedText);
    }
  } catch (error) {
    if (error.name === 'AbortError' || error.message.includes('cancellation of share')) {
      console.warn('Share was cancelled by the user or due to a system restriction:', error);
    } else if (error.name === 'InvalidStateError' && error.message.includes('share() is already in progress')) {
      console.warn('Share is already in progress. Please wait until it is complete.');
    } else {
      throw error;
    }
  } finally {
    isSharingInProgress = false;
  }
}
